// The minimized GET /networks payload wraps each network as
// { network, regions, instanceCount, tunnelCount }: region ids live on
// network.regions, instance ids on region.instances, and the per-instance
// tunnel objects are collapsed into a single tunnelCount. This flattens each
// entry back to the legacy per-network shape so the networksGet saga transform
// and every consumer (Networks list, Applications, Policies, Create/Edit) keep
// working unchanged. hasFailures lives on the network object, so the spread
// carries it through.
export function normalizeV2NetworkListItem(item) {
  const { network, regions = [], tunnelCount = 0 } = item;

  const reconstructedRegions = regions.map((region, regionIndex) => ({
    ...region,
    instances: (region.instances || []).map((instanceId, instanceIndex) => ({
      id: instanceId,
      objectId: instanceId,
      // CONTRACT: only the per-network TOTAL is reconstructed, by parking every
      // tunnel on the first instance of the first region. The distribution
      // across instances is therefore fake. Callers may sum
      // instances[].tunnels.length across a network; they must not read the
      // tunnel count of any individual instance or region, and must not read
      // the tunnel objects themselves — they are empty placeholders. The
      // minimized payload does not carry the data needed to do better.
      tunnels:
        regionIndex === 0 && instanceIndex === 0
          ? Array.from({ length: tunnelCount }, () => ({}))
          : [],
    })),
  }));

  return { ...network, regions: reconstructedRegions };
}
